class DstCountdown extends HTMLElement {
  connectedCallback() {
    this._target = new Date(this.dataset.target).getTime();
    this._expiredText = this.dataset.expiredText || '';
    if (isNaN(this._target)) return;
    this._tick();
    this._timer = setInterval(() => this._tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this._timer);
  }

  _tick() {
    const diff = this._target - Date.now();

    if (diff <= 0) {
      clearInterval(this._timer);
      this.classList.add('is-expired');
      if (this._expiredText) {
        this.textContent = this._expiredText;
      } else {
        this.hidden = true;
      }
      return;
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.textContent = `${days}d ${this._pad(hours)}h ${this._pad(minutes)}m ${this._pad(seconds)}s`;
  }

  _pad(n) {
    return String(n).padStart(2, '0');
  }
}

customElements.define('dst-countdown', DstCountdown);
